'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
require('./Badge.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Badge = function (_a) {
    var title = _a.title, className = _a.className, status = _a.status, size = _a.size;
    return (React__default['default'].createElement("div", { "data-testid": "badge__component", className: index['default']("badge", [size && "lp-badge--" + size, status && "lp-badge--" + status, className && className]) },
        React__default['default'].createElement("span", { className: 'badge__title' }, title)));
};

exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map
